import clsx from "clsx";

/**
 * Classes CSS para o container do FormSelect
 */
export function getFormSelectContainerClasses(className?: string): string {
  return clsx("space-y-1.5", className);
}

/**
 * Classes CSS para o label - AJUSTADO
 */
export function getFormSelectLabelClasses(
  required: boolean = false,
  hasError: boolean = false
): string {
  return clsx(
    "block text-xs font-semibold font-montserrat mb-1",
    {
      "text-raro-gray-700": !hasError,
      "text-red-600": hasError,
    },
    required && "after:content-['*'] after:text-red-500 after:ml-1"
  );
}

/**
 * Classes CSS para o select - AJUSTADO: menor, menos arredondado e seta melhor posicionada
 */
export function getFormSelectClasses(hasError: boolean = false): string {
  return clsx(
    // Classes base - AJUSTADO: padding menor e border radius menor
    "w-full !mt-0.5 px-3 py-2 font-montserrat rounded-lg border transition-all duration-200 ",
    "text-sm focus:outline-none focus:ring-1",
    "appearance-none bg-white cursor-pointer",

    // Ícone de dropdown - AJUSTADO: melhor posicionamento e tamanho
    "bg-no-repeat bg-right bg-[length:16px] pr-8",
    "bg-[position:right_0.75rem_center]",
    "bg-[url(\"data:svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\")]",

    // Estados condicionais
    {
      // Estado normal
      "border-raro-gray-300 focus:border-primary-500 focus:ring-primary-500/20":
        !hasError,

      // Estado de erro
      "border-red-500 focus:border-red-500 focus:ring-red-500/20 bg-red-50":
        hasError,
    }
  );
}

/**
 * Classes CSS para mensagem de erro - AJUSTADO
 */
export function getSelectErrorMessageClasses(): string {
  return clsx("text-xs text-red-600 font-montserrat mt-1");
}

/**
 * Classes CSS para texto de ajuda - AJUSTADO
 */
export function getSelectHelperTextClasses(): string {
  return clsx("text-xs text-raro-gray-500 font-montserrat mt-1");
}
